var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "arrow_drop_down_circle-24px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2394",
    "data-name": "Caminho 2394",
    d: "M0,0H24V24H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2395",
    "data-name": "Caminho 2395",
    d: "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,12L8,10h8Z",
    fill: "#95989a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDrop);
export default __webpack_public_path__ + "static/media/Arrow_drop.5c2cef60.svg";
export { ForwardRef as ReactComponent };